module.exports = __webpack_public_path__ + "static/media/close.3768991c.svg";